module.exports = __webpack_public_path__ + "img/mouse.27b7bcae.svg";